// Item types

export const ITEM_TEXT = 'text';
export const ITEM_VARIABLE = 'variable';
export const ITEM_BARCODE = 'barcode';
export const ITEM_RECTANGLE = 'rectangle';
export const ITEM_ELLIPSE = 'ellipse';
export const ITEM_LINE = 'line';
export const ITEM_IMAGE = 'image';

export const FILL_COLOR_VARIABLE_CODE = 'color.rgbHex';
export const FILL_COLOR_VARIABLE_PLACEHOLDER = `[${FILL_COLOR_VARIABLE_CODE}]`;
